import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { handleClickScroll } from "utils";
import {
  MainSection,
  AboutSection,
  ContactSection,
  NewsletterSection,
  PortfolioSection,
  ServicesSection,
} from "./components";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state) handleClickScroll(location.state.scrollTo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <MainSection />
      <AboutSection />
      <NewsletterSection />
      <ServicesSection />
      <PortfolioSection />
      <ContactSection />
    </div>
  );
};

export default Home;
